import React, { Component } from 'react';
import { alert_headers } from '../../../../model/alerts/alert-headers';
import { redirectToDismissAlert } from '../../../../routing/redirectService';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../services/Paging';
import { fetchAlerts, resetAlerts } from './redux/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { AlertsTable } from '../../../../shared/table/AlertsTable';
import {
    getSelectedBrandId,
    getSelectedJurisdictionCode
} from '../../../../jurisdiction/redux/selectors';
import { makeRuleTypeDropdownOptions } from '../../../../shared/models/rule-type';
import { getStatusAsBoolean } from '../../../../shared/models/status';
import { delegateAlert } from '../delegate/redux/actions';
import * as _ from 'lodash';

class AlertsListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                pageSize: defaultItemsPerPage,
                page: defaultFirstPage
            },
            dismissed: null,
            filters: {
                type: null,
                severity: null,
                status: null
            },
            username: null,
            sort: {}
        };
    }

    makeFiltersConfig = () => ({
        typeConfig: {
            label: 'Rule Type',
            options: makeRuleTypeDropdownOptions()
        },
        severityConfig: {},
        statusConfig: {}
    });

    componentDidMount() {
        this.fetchAlertsFromState();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            !isEqual(prevProps.jurisdictionCode, this.props.jurisdictionCode) ||
            !isEqual(prevProps.brandId, this.props.brandId)
        ) {
            this.fetchAlertsFromState();
        }
    }

    componentWillUnmount() {
        this.props.resetAlerts();
    }

    fetchAlertsFromState() {
        const { jurisdictionCode, brandId, ruleCategory } = this.props;
        const { sortingKey, sortDirection } = this.state.sort;
        const { type, severity, status } = this.state.filters;
        const { pagination, username } = this.state;

        this.props.fetchAlerts({
            jurisdictionCode,
            brandId,
            // todo: Filtering by dismissType is not implemented on the BE.
            //  This is a temporary solution to make the status filtering work.
            dismissed: getStatusAsBoolean(status),
            pagination,
            sort: {
                sortType: sortingKey,
                sortOrder: sortDirection
            },
            username,
            ruleType: type,
            alertLevel: severity,
            ruleCategory
        });
    }

    dismissAlert(alert) {
        redirectToDismissAlert(alert.rule.category, alert);
    }

    delegateAlerts = (alertId, teamIds) => {
        _.isFunction(this.props.delegateAlert) &&
            this.props.delegateAlert(alertId, teamIds);
    };

    updatePagination = pagination =>
        this.setState(
            {
                ...this.state,
                pagination
            },
            () => this.fetchAlertsFromState()
        );

    updateSort = sort =>
        this.setState(
            {
                ...this.state,
                sort
            },
            () => this.fetchAlertsFromState()
        );

    handleApplyFilters = filters => {
        this.setState(
            {
                ...this.state,
                pagination: {
                    ...this.state.pagination,
                    page: defaultFirstPage
                },
                filters
            },
            () => this.fetchAlertsFromState()
        );
    };

    handleClearFilters = () =>
        this.setState(
            {
                ...this.state,
                pagination: {
                    pageSize: defaultItemsPerPage,
                    page: defaultFirstPage
                },
                filters: {
                    ruleType: null,
                    alertLevel: null,
                    status: null
                },
                dismissed: false
            },
            () => this.fetchAlertsFromState()
        );

    handleRemoveFilter = filters =>
        this.setState(
            {
                ...this.state,
                filters
            },
            () => this.fetchAlertsFromState()
        );

    handleSearchByUsername = username =>
        this.setState(
            {
                ...this.state,
                pagination: {
                    ...this.state.pagination,
                    page: defaultFirstPage
                },
                username
            },
            () => this.fetchAlertsFromState()
        );

    render() {
        const { alerts, loading } = this.props;

        return (
            <AlertsTable
                headers={alert_headers}
                data={alerts}
                dismissAlert={this.dismissAlert.bind(this)}
                delegateAlert={this.delegateAlerts}
                loading={loading}
                pagination={{
                    ...this.state.pagination,
                    hasNextPage: this.props.pagination.hasNextPage
                }}
                onPaginationUpdated={pagination =>
                    this.updatePagination(pagination)
                }
                onSortUpdated={sort => this.updateSort(sort)}
                filters={this.state.filters}
                filtersConfig={this.makeFiltersConfig()}
                applyFilters={this.handleApplyFilters}
                clearFilters={this.handleClearFilters}
                removeFilter={this.handleRemoveFilter}
                searchByUsername={this.handleSearchByUsername}
            />
        );
    }
}

const mapStateToProps = state => {
    const { loaded, loading, error, data, pagination } = state.alerts;
    const jurisdictionCode = getSelectedJurisdictionCode(state);
    const brandId = getSelectedBrandId(state);

    return {
        jurisdictionCode,
        brandId,
        alerts: data,
        pagination,
        loaded,
        loading,
        error
    };
};
const mapDispatchToProps = dispatch => ({
    fetchAlerts: args => dispatch(fetchAlerts(args)),
    resetAlerts: () => dispatch(resetAlerts()),
    delegateAlert: (alertId, teamIds) =>
        dispatch(delegateAlert({ alertId, teamIds }))
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AlertsListContainer)
);
